<div class="col-md-12 mb-30" [hidden]="Selected_Schedule_Record.id>0 || FormTypeShow!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات برنامه ریزی مدیر</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام مشتری</label>
          <input [(ngModel)]="Filter_customerName" (keyup)="Change_Filter_title()" name="Filter_customerName" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">شماره نامه</label>
          <input [(ngModel)]="Filter_letterCode" (keyup)="Change_Filter_title()" name="Filter_letterCode" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام و نام خانوادگی</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Schedule()" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه درخواست</th>
              <th>نام و نام خانوادگی</th>
              <th>زمان ماموریت</th>
              <th>شماره نامه</th>
              <th>نام مشتری</th>

              <th>زمان ثبت</th>
              <th>گردش کار</th>
              <th>وضیعت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of DataList_Schedule
                  |filter:Filter_letterCode:'letterCode'
                  |filter:Filter_customerName:'customerName'
                  |filter:Filter_title:'fullname'
                  | paginate
                          : {
                              id: 'DataList_FeildTable',
                              itemsPerPage: 50,
                              currentPage: page,
                              totalItems: (DataList_Schedule
                              |filter:Filter_letterCode:'letterCode'
                                          |filter:Filter_customerName:'customerName'
                                          |filter:Filter_title:'fullname'
                                        ).length
                            }">

              <tr>
                <td>{{DataList_Schedule.indexOf(item)+1}}</td>
                <td>{{item.id}}</td>
                <td>{{item.fullname}}</td>
                <td>{{item.persianDate}} از {{item.startDate}} تا {{item.endDate}}</td>

                <td>{{item.letterCode}}</td>
                <td>{{item.customerName}}</td>


                <td>{{item.persianDate2}}</td>
                <td>{{item.flowchart.flochart_title}}</td>
                <td>
                  <p *ngIf="item.statusStr==1" style="color: rgb(20, 77, 220);">در حال بررسی</p>
                  <p *ngIf="item.statusStr==2" style="color: #489b39;">تایید</p>
                  <p *ngIf="item.statusStr==3" style="color: crimson;">عدم تایید</p>
                </td>

                <td rowspan="2">
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" *ngIf="!item.sms" (click)="ReadData_Form(item)"
                          class="dropdown-item"><i class="fa fa-eye"></i> مشاهده </a>
                        <a style="cursor: pointer;" *ngIf="item.sms" (click)="ReadData_Form(item)"
                          class="dropdown-item"><i class="fa fa-eye"></i> عدم مشاهده </a>
                        <a *ngIf="item.status==2" style="cursor: pointer;" (click)="ReadData_View(item)"
                          class="dropdown-item"><i class="fa fa-leanpub"></i> بازنگری
                        </a>
                        <a href="{{BaseUrl1}}{{item.flowchart.flochart_id}}{{BaseUrlCo}}{{item.flowchart.makerId}}"
                          target="_blank" class="dropdown-item"><i class="fa fa-wpbeginner"></i>
                          گردش کار
                        </a>
                        <a style="cursor: pointer;" (click)="ReadData_History(item)" class="dropdown-item"><i
                            class="fa fa-history"></i>
                          تاریخچه گردش کار
                        </a>

                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th colspan="2">توضیحات</th>
                <td colspan="7">{{item.dsc}}</td>
              </tr>
              <tr *ngIf="item.sms">
                <td colspan="7">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #396c9b; color: white;">
                      <tr>
                        <th>#</th>
                        <th>نام</th>
                        <th>نام خانوادگی</th>
                        <th>کد ملی</th>
                        <th>شماره همراه</th>
                        <th>نام پدر</th>
                        <th>سرپرست</th>
                        <th>امکانات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let detail of item.expert">
                        <td>{{item.expert.indexOf(detail)+1}}</td>
                        <td>{{detail.name}}</td>
                        <td>{{detail.familly}}</td>
                        <td>{{detail.melicode}}</td>
                        <td>{{detail.shomareh_Hamreh}}</td>
                        <td>{{detail.name_Pedar}}</td>
                        <td>
                          <p *ngIf="detail.seleted">بله</p>
                          <p *ngIf="!detail.seleted">خیر</p>
                        </td>

                      </tr>
                    </tbody>
                  </table>

                </td>
              </tr>

            </ng-container>

          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<div *ngIf="FormTypeShow=='History'" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">تاریخچه گردش درخواست '{{Selected_Schedule_Record.flowchart.uniCode}}'
          </h5>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">
            <app-FlowchartHistory [DataList_History]="DataList_History"></app-FlowchartHistory>
          </div>

        </div>


      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-left: 5px;"> بازگشت
    </button>
  </div>

</div>